<template>
  <FormModel
      ref="form" :action="submit"
      :labelCol="{span:4}" :model="info" :rules="rules"
      :wrapperCol="{span: 20}" class="album-form" v-on="$listeners">
    <a-alert :show-icon="true" type="warning">
      <div slot="message">
        <div>* 请在拍摄时间的提前7天 ~ 延后7天内完成图片上传，逾期无法上传</div>
      </div>
    </a-alert>
    <div style="margin-top:20px;">
      <a-form-model-item label="相册名称" prop="name">
        <a-input placeholder="请输入相册名称" v-model="info.name"/>
      </a-form-model-item>
      <a-form-model-item label="所属分类" prop="cate">
        <AlbumCate placeholder="请选择相册分类" v-model="info.cate"/>
      </a-form-model-item>
    </div>
    <a-row :gutter="15">
      <a-col span="12">
        <a-form-model-item :labelCol="{span:8}" :wrapperCol="{span: 16}" label="拍摄日期" prop="period.0" required>
          <DatePicker :disabledDate="disabledStartDate" format="YYYY-MM-DD" placeholder="拍摄开始时间" style="min-width: 100%"
                      v-model="info.period[0]"/>
        </a-form-model-item>
      </a-col>
      <a-col span="12">
        <a-form-model-item :labelCol="{span:0}" :wrapperCol="{span: 24}" prop="period.1">
          <DatePicker :disabledDate="disabledFinishDate" format="YYYY-MM-DD" placeholder="拍摄结束时间"
                      style="min-width: 100%" v-model="info.period[1]"/>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row :gutter="15">
      <a-col span="12">
        <a-form-model-item
            :labelCol="{span:8}" :wrapperCol="{span: 16}"
            label="拍摄地点" prop="address">
          <AreaPicker :level="2" placeholder="请选择拍摄城市" v-model="info.address"/>
        </a-form-model-item>
      </a-col>
      <a-col span="12">
        <a-input placeholder="详细地址，非必填" v-model="info.address[2]"/>
      </a-col>
    </a-row>
    <a-form-model-item label="简介描述" prop="desc">
      <a-input placeholder="相册简要描述，非必填，控制在1024个字符内" rows="6" type="textarea" v-model="info.desc"/>
    </a-form-model-item>
  </FormModel>
</template>

<script>
import api from "../../../../utils/api";
import func from "../../../../utils/func";
import cache from "../../../../utils/cache";
import moment from "moment";
import AlbumCate from "./AlbumCate";
import AreaPicker from "../../../../comps/AreaPicker";
import DatePicker from "../../../../comps/DatePicker";
import FormModel from "../../../../comps/FormModel";

export default {
  name: "AlbumForm",
  components: {FormModel, DatePicker, AreaPicker, AlbumCate},
  props: {album: Object},
  data() {
    return {
      info: {
        name: "",
        cate: "",
        cover: "",
        period: [0, 0],
        address: [0, "", ""],
        desc: "",
        platform: "efoto.pc",
      },
      rules: {
        name: {required: true, message: "相册名称不能为空"},
        cate: {required: true, message: "请选择相册所属分类"},
        "period.0": {type: "integer", min: 1, message: "请选择拍摄开始时间"},
        "period.1": {type: "integer", min: 1, message: "请选择拍摄结束时间"},
        address: {
          type: 'array',
          required: true,
          fields: {
            0: {required: true, message: "请选择相册拍摄地点"}
          }
        },
      },
      duration: 14 * 24 * 3600
    };
  },
  mounted() {
    if (func.isDefined(this.album) && this.album.id) {
      this.info = func.copyObject(this.album.info)
    }
  },
  methods: {
    submit() {
      let period = this.info.period;
      if (period[1] - period[0] > this.duration) {
        return Promise.reject("拍摄时长不超过14天");
      }
      return func.isDefined(this.album) && this.album.id
          ? cache.v1.album.setInfo(this.album.id, this.info)
              .then(() => this.album.info = this.info)
          : api.v1.album.create(this.info).then(res => {
            return api.v1.album.member.ready(res.id, false);
          });
    },
    disabledStartDate(current) {
      if (!this.info.period[1]) return;
      return current > moment(func.tsFormat(this.info.period[1], "YYYY-MM-DD"), "YYYY-MM-DD");
    },
    disabledFinishDate(current) {
      if (!this.info.period[0]) return;
      return current < moment(func.tsFormat(this.info.period[0], "YYYY-MM-DD"), "YYYY-MM-DD");
    },
  }
}
</script>
